module.exports = __webpack_public_path__ + "static/media/ig.227f4b72.svg";